import { useCollection, useDocument } from "../../hooks/useFirestore"
import { createManagedMutations } from "../../hooks/useManagedMutations"
import { collectionName, User } from "./user"

export function useUser({ id }: { id?: string }) {
   return useDocument<User>(collectionName, id)
}

export function useUsers() {
   return useCollection<User>({ collectionName })
}

// Hooks de mutation génériques
export const { useUpdateManagedDocument: useUpdateUser } =
   createManagedMutations<User>(collectionName)
